module.exports = __webpack_public_path__ + "media/images/icons/icon_user_circle-9fc95104634618f52ac0d636c858e2ef.svg";